<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">我们的服务</div>
    <div class="title-sub">
      我们对互联网+的未来充满信心，肩负实现中国企业互联网+转型升级的伟大使命。 未来属于强者，属于具有战略眼光的人，我们将和众多服务客户及合作伙伴共同成长，一起见证中国移动互联网的伟大变革。
    </div>
    <div class="list">
      <div class="item">
        <div class="pic"><img src="@/assets/img/service-01.png"></div>
        <div class="name">软件与技术服务</div>
        <div class="sub">APP/软件定制开发、企业管理系统定制、高端网站定制、小程序/公众号开发</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/service-02.png"></div>
        <div class="name">人工智能</div>
        <div class="sub">机器视觉，指纹识别，人脸识别，视网膜识别，掌纹识别</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/service-03.png"></div>
        <div class="name">大数据中心</div>
        <div class="sub">数据的资源化、与云计算的深度结合</div>
      </div>
      <div class="item two-item">
        <div class="pic"><img src="@/assets/img/service-04.png"></div>
        <div class="name">5G新基建</div>
        <div class="sub">5G、人工智能、工业互联网、物联网新型基础设施</div>
      </div>
      <div class="item two-item">
        <div class="pic"><img src="@/assets/img/service-05.png"></div>
        <div class="name">工业互联网</div>
        <div class="sub">结合软件和大数据分析，重构全球工业、激发生产力</div>
      </div>
    </div>
    <router-link class="show-more" to="/service">更多服务>></router-link>
  </div>
</div>
</template>

<script>
export default {
  name: ''
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    overflow: visible;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        width: 150px;
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 18px;
        box-sizing: border-box;
      }
      .title-sub{
        width: 1039px;
        height: 48px;
        color: #666666;
        transform: .5s;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        box-sizing: border-box;
      }
      .list{
        margin-top: 50px;
        width: 100%;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        .item{
          width: 380px;
          height: 250px;
          margin-bottom: 30px;
          overflow: visible;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #FFFFFF;
          cursor: pointer;
          box-sizing: border-box;
          .pic{
            width: 70px;
            height: 66px;
            margin-top: 27px;
            margin-bottom: 20px;
            box-sizing: border-box;
            img{
              width: 100%;
            }
          }
          .name{
            height: 30px;
            color: #333333;
            transform: .5s;
            line-height: 30px;
            font-weight: 600;
            font-size: 22px;
            text-align: center;
            margin-bottom: 30px;
            min-width: 132px;
            box-sizing: border-box;
          }
          .sub{
            width: 300px;
            height: 48px;
            color: #666666;
            transform: .5s;
            line-height: 24px;
            font-size: 16px;
            text-align: center;
            box-sizing: border-box;
          }
        }
        .two-item{
          width: 585px;
          height: 225px;
          .sub{
            width: 450px;
            height: 24px;
          }
        }
      }
    }
}
</style>
